var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3787 6.5L5.62132 6.5C4.28496 6.5 3.61571 8.11571 4.56066 9.06066L8.93934 13.4393C9.52513 14.0251 10.4749 14.0251 11.0607 13.4393L15.4393 9.06066C16.3843 8.11571 15.715 6.5 14.3787 6.5Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownButton);
export default __webpack_public_path__ + "static/media/dropdown-button.ff4c1dfa0ee16cd8899d55486d260b31.svg";
export { ForwardRef as ReactComponent };